export const EXTENSION_URL =
  'https://chromewebstore.google.com/detail/careerio-job-auto-apply/aelljdlolpakdoeongoklpkheedfjkio'
export const EXTENSION_ID = 'aelljdlolpakdoeongoklpkheedfjkio'
